/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Readiness_FreshInputs */

const en_ui_readiness_fresh = /** @type {(inputs: Ui_Readiness_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go`)
};

const de_ui_readiness_fresh = /** @type {(inputs: Ui_Readiness_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grün`)
};

/**
* | output |
* | --- |
* | "Go" |
*
* @param {Ui_Readiness_FreshInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_readiness_fresh = /** @type {((inputs?: Ui_Readiness_FreshInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Readiness_FreshInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_readiness_fresh(inputs)
	return de_ui_readiness_fresh(inputs)
});